import { styled, Theme, Tabs, TextField, Select } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
const commonStyles = ({
  theme,
  editable,
}: {
  theme: Theme;
  editable: boolean;
}) => ({
  "& .MuiInputBase-root": {
    backgroundColor: editable ? "#FAFBFC" : "#F4F6F9",
    borderBottom: editable ? `1px solid #3E5463` : "none",
    overflow: "hidden",
  },
  "& .MuiInputBase-input": {
    color: "#1C2B36",
    padding: "8px 14px",
    overflowY: "scroll",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  "& .MuiFormLabel-root": {
    position: "relative",
    transform: "none",
    marginBottom: "8px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    borderBottom: editable ? `1px solid #3E5463` : "",
  },
});

export const removeMethodOfContactOption = "Remove Method of Contact";
export const noneOption = "None";
export const menuProps = {
  PaperProps: {
    sx: {
      maxHeight: 300,
      "& .MuiMenuItem-root": {
        height: 30,
      },
    },
  },
};
export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  "& .MuiTabs-flexContainer": {
    justifyContent: "space-between",
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minWidth: "auto",
    padding: "12px 16px",
    flex: 1,
    fontSize: "14px",
    fontWeight: "bold",
  },
}));
export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "editable",
})<{ editable?: boolean }>((props) =>
  commonStyles({ ...props, editable: props.editable ?? false })
);
export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== "editable",
})<{ editable?: boolean }>((props) =>
  commonStyles({ ...props, editable: props.editable ?? false })
);
export const StyledDatePicker = styled(DatePicker, {
  shouldForwardProp: (prop) => prop !== "editable",
})<{ editable?: boolean }>((props) =>
  commonStyles({ ...props, editable: props.editable ?? false })
);

